import { useContext } from 'react';
import { AuthContext, type IAuthContext } from 'react-oauth2-code-pkce';

export const useToken = (): string => {
  const { token } = useContext<IAuthContext>(AuthContext);
  return token;
};
